export default __webpack_public_path__ + "static/media/allDemosbg.db84dac8.jpg";